import { PrankDefinition, Intensity } from './types';

const TICK_MS = 15000;
const OPACITY_STEP = 0.005;
const MIN_OPACITY = 0.3;
const INTENSE_MULTIPLIER = 5;

const fadePrank: PrankDefinition = {
  namedCode: 'fade',
  hexCode: 'e2b8',
  create: (intensity) => {
    const speed = intensity === Intensity.INTENSE ? INTENSE_MULTIPLIER : 1;
    let opacity = 1;

    const interval = setInterval(() => {
      opacity = Math.max(MIN_OPACITY, opacity - OPACITY_STEP);
      document.documentElement.style.opacity = String(opacity);
    }, TICK_MS / speed);

    return () => {
      clearInterval(interval);
      document.documentElement.style.opacity = '';
    };
  },
};

export default fadePrank;
